export enum CollectionType {
  MILLYS = "Milly's",
  PARCEL_HERO = "ParcelHero",
  EXPEDITORS = "Expeditors",
  BRAND_SHIPS = "Brand Ships"
}
